import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { Activity } from '../interfaces';
import { falconClient } from '@/data/@clients';
import { clientKeys } from '@/data/@clients/client-keys';
import { baseUrl } from '@/data/idp/base';

export const useReorderActivities = (planId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (activities: Activity[]) => {
      const activitiesIds = activities.map((activity) => ({ id: activity.id }));
      return falconClient.patch(`${baseUrl}/plans/${planId}/order_activities`, {
        plan: { activities_attributes: activitiesIds },
      });
    },
    onSuccess: async () => {
      queryClient.invalidateQueries({
        queryKey: [clientKeys.usePlanShow, planId],
      });
    },
  });
};
